import { useState, useEffect, useCallback } from 'react'
import '../inquiry/telephonic/telephonic.scss'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { numbers, ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import PageDropdown from '../../components/page-dropdown/PageDropdown'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import TableDateInput from '../../components/table-date-input/TableDateInput'
import {getAllExam}  from '../../store/builders/exam-assessment/exam-assessment.builder'
import { capitalizeFirstLetter } from '../../utility/genricFunction'
import ServerParentDataTable from '../../components/data-table/ServerParentDataTable'
import Loader from '../../components/loader/Loader'

const FacultyExamAssessment = () => {
  const dispatch = useDispatch()
  const { allExam,loading, examAssessPageData } = useSelector((state) => state.allexam)
 const facultyId = useSelector((state) => state?.auth?.user?.result?.facultyId)

 
  const navigate = useNavigate()
  const [selectedNumber, setSelectedNumber] = useState(numbers[0].value)
  const [filters, setFilters] = useState({})
  const [page, setPage] = useState(1)
  
  useEffect(() => {
    const newFilters = { ...filters }

    newFilters.limit = {
      value: selectedNumber,
      matchMode: 'startsWith',
    }

    newFilters.page = {
      value: page,
      matchMode: 'startsWith',
    }

    const keysToIgnore = ['limit', 'page']
    const areAllOtherKeysNull = Object.keys(filters).every(
      (key) => keysToIgnore.includes(key) || filters[key].value === null || filters[key].value === '',
    )
    
    if (areAllOtherKeysNull) {
      facultyId && dispatch(getAllExam({ facultyId, filters: newFilters }))  
    } else {
      facultyId && Object.keys(filters).length && dispatch(getAllExam({ facultyId, filters }))
    }

    return () => dispatch({ type: 'allexam/clearExtraReducers' })
  }, [filters, selectedNumber, page, dispatch]) 

  const nameBodyTemplate = (allExam) => {
    return <p onClick={()=>handleClickMe(allExam)} style={{ cursor: 'pointer' }}>{allExam.courseModule}</p>
  }

  const branchBody = (allExam) => {
    const representative = allExam?.branch && capitalizeFirstLetter(allExam?.branch)
    return (
      <div className='flex align-items-center gap-2'>
        <span>{representative}</span>
      </div>
    )
  }

  function handleClickMe(allExam) {
    const timeTableId = allExam.lectureTimeTableId;
    navigate(`/exam-assessment/faculty/result/${timeTableId}`)
  }

  let timer;
  const onFilterChange = (e) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      setFilters(e.filters)
    }, 1000);
  }

const handleChangePageLimit = (e) => {
  setSelectedNumber(Number(e.value))
  setPage(1)
}

  const columns = [
    {
      sortable: true,
      field: 'courseModule',
      header: 'Exam',
      filter: true,
      filterDisplay: 'row',
      filterPlaceholder: 'Search by name...',
      style: { minWidth: '12rem' },
      body: nameBodyTemplate
    },
    {
      sortable: true,
      field: 'date',
      header: 'Date',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by date...',
      filterElement: TableDateInput,
    },
    {
      sortable: true,
      field: 'batch',
      header: 'Batch',
      style: { minWidth: '12rem' },
      filter: true,
      filterPlaceholder: 'Search by batch...',
    },
    {
      sortable: true,
      field: 'course',
      header: 'Course',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by course...',
    },
    {
      sortable: true,
      field: 'branch',
      header: 'Branch',
      filter: true,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by branch...',
      body:branchBody
    },
    {
      sortable: true,
      field: 'studentCount',
      header: 'Total Attendees',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '12rem' },
      filterPlaceholder: 'Search by attendees...',
    },
    {
      sortable: true,
      field: 'pendingResultCount',
      header: 'Pending Results',
      filter: false,
      filterDisplay: 'row',
      style: { minWidth: '11rem' },
      filterPlaceholder: 'Search by results...',
    }

  ]

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.EXAM_ASSESSMENT.LABEL_EXAM_ASSESSMENT,
      link: null,
    },
    {
      title:  UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.FACULTY_DASHBOARD,
    },
    {
      title: UI_CONSTANT.EXAM_ASSESSMENT.LABEL_EXAM_ASSESSMENT,
      link: ROUTES_PATH.FACULTY_EXAM_ASSESSMENT,
    },
  ]


  return (
    <>
      {/* <div className={`telephonic-container flex flex-column`}> */}
      {loading && <Loader loading={loading} />}

     {<Loader loading={loading} /> &&  <div className={`course-list }`}>
        <div className='filter-bar-wraper'>
          <div className='subheader'>
            <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
          </div>
        </div>

        <div className='group-parent'>
          <div className='frame-wrapper'>
            <div className='course-list-wrapper'>
              <b className='course-list1'>{UI_CONSTANT.EXAM_ASSESSMENT.ALL_EXAM}</b>
            </div>
          </div>
          <div className='flex page-drop-div'>
            <p className='page-sidetext'>{UI_CONSTANT.TABLE_HEADER_SAW}</p>
            <PageDropdown
              options={numbers}
              selectedValue={selectedNumber}
              onChange={(e) => handleChangePageLimit(e)}
              className='w-full md:w-14rem small-dropdown'
            />
            <p className='page-endtext'>{UI_CONSTANT.TABLE_HEADER_ENTRIES}</p>
          </div>
        
          <div className='table-card'>
            <ServerParentDataTable
              value={allExam}
              rows={selectedNumber}
              filters={filters}
              // loading={loading}
              columns={columns}
              onFilter={onFilterChange}
              isServerSide={true}
              pageChange={(e)=>setPage(Number(e.page) + 1)}
              totalRecords={examAssessPageData?.pagination?.totalItems }
            />
          </div>
        </div>

        {/* <BranchTable /> */}
        {/* </div> */}
      </div>}
    </>
  )
}

export default FacultyExamAssessment
